// Services/CourseService.js
import api from "Common/Client/Interceptor";

export const fetchCoursesList = async ({
  pageNumber = 1,
  pageSize = 6,
  orderByLatest = true,
  isPublished
} = {}) => {
  try {
    const response = await api.get("/indv/Course/Get-List", {
      params: {
        PageNumber: pageNumber,
        PageSize: pageSize,
        OrderByLatest: orderByLatest,
        ...(typeof isPublished === "boolean" && { isPublished })
      }
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching courses:", error);
    throw error;
  }
};


export const getCategories = async () => {
  try {
    console.log(" Fetching categories list...");
    
    const response = await api.get("/indv/CourseCategory/list");
    
    console.log(" categories data received:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error fetching categories:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });
    throw error;
  }
};



// Get subcategories for a specific category
export const getSubCategories = async (categoryId) => {
  try {
    const response = await api.get(`/indv/CourseCategory/${categoryId}/subcategories`);
    console.log("sub categories ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching subcategories:", error);
    throw error;
  }
};

 


 
export const fetchCourseDetails = async (courseId) => {
  try {
    console.log(" Fetching course details for ID:", courseId);
    
    const response = await api.get(`/indv/Course/Get-With-Detail/${courseId}`);
    
    
    console.log(" Course details received:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error fetching course details:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });
    throw error;
  }
};

// module details
export const fetchModuleWithDetails = async (moduleId) => {
  try {
    console.log(" Fetching module details for ID:", moduleId);
    
    const response = await api.get(`/indv/CourseModule/Get-With-Detail/${moduleId}`);
    
    console.log("Module details received:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error fetching module details:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });
    throw error;
  }
};



// Get single assessment by ID
export const getAssessmentById = async (assessmentId) => {
  try {
    console.log(" Fetching assessment details for ID:", assessmentId);
    
    const response = await api.get(`/indv/Assessment/Get-Single/${assessmentId}`);
    
    console.log(" Assessment details received:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error fetching assessment details:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });
    throw error;
  }
};

// Update assessment
export const updateAssessment = async (assessmentData) => {
  try {
    console.log(" Updating assessment...", assessmentData);

    // Validate required fields
    if (!assessmentData.assessmentId) {
      throw new Error("Assessment ID is required");
    }

    if (!assessmentData.title || !assessmentData.title.trim()) {
      throw new Error("Assessment title is required");
    }

    if (!assessmentData.questions || !Array.isArray(assessmentData.questions) || assessmentData.questions.length === 0) {
      throw new Error("At least one question is required");
    }

    // Validate questions structure
    for (let i = 0; i < assessmentData.questions.length; i++) {
      const question = assessmentData.questions[i];
      
      if (!question.questionText || !question.questionText.trim()) {
        throw new Error(`Question ${i + 1} text is required`);
      }

      if (!question.options || !Array.isArray(question.options) || question.options.length < 3) {
        throw new Error(`Question ${i + 1} must have at least 3 options`);
      }

      // Validate options
      for (let j = 0; j < question.options.length; j++) {
        const option = question.options[j];
        
        if (!option.text || !option.text.trim()) {
          throw new Error(`Option ${j + 1} in question ${i + 1} must have text`);
        }

        // Ensure isCorrect is boolean
        if (typeof option.isCorrect !== 'boolean') {
          option.isCorrect = option.isCorrect === "true" || option.isCorrect === true;
        }
      }

      // Validate at least 1 correct answers
     const correctOptions = question.options.filter(opt => opt.isCorrect === true);
if (correctOptions.length < 1) {
  throw new Error(`Question ${i + 1} must have at least one correct answer`);
}

    }

    const payload = {
      assessmentId: parseInt(assessmentData.assessmentId),
      title: assessmentData.title.trim(),
      questions: assessmentData.questions.map((question, index) => ({
        questionText: question.questionText.trim(),
        order: parseInt(question.order) || (index + 1),
      options: question.options.map((option) => ({
  text: option.text.trim(),
  isCorrect: option.isCorrect === true || option.isCorrect === "true"
}))
      }))
    };

    console.log(" Update assessment payload:", JSON.stringify(payload, null, 2));

    const response = await api.put("/indv/Assessment/Update", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    console.log(" Assessment updated successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error updating assessment:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });

    if (error.response?.data?.errors) {
      console.error("📋 Assessment validation errors:", error.response.data.errors);
    }

    throw new Error(
      error.response?.data?.title ||
        error.response?.data?.message ||
        error.response?.data?.details ||
        error.message ||
        "Failed to update assessment"
    );
  }
};



// Create new course
export const createCourse = async (courseData) => {
  try {
    console.log("........... Creating new course.... in service ", courseData);
   

    const payload = {
      title: courseData.title,
      description: courseData.description,
      categoryId: courseData.categoryId,
      subCategories: courseData.subCategories || [],
      prerequisites: courseData.prerequisites || [],
      courseAuthorId: courseData.courseAuthorId || null,
      courseAuthor: courseData.courseAuthor || null,
      isPaid: true,  
    }
         if (payload.isPaid) {
  payload.pricing ={
    price: 97.99,
    accessDurationDays: 180
  }
}
  
 

    console.log("?????????????????Final Create Payload:...", payload);

    const response = await api.post("/indv/Course/Create", payload);
    return response.data;
  } catch (error) {
    console.error(" Error creating course:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });
    throw error;
  }
};



// Get list of authors
export const fetchAuthorsList = async ({
  pageNumber = 1,
  pageSize = 10,
  orderByLatest = true
} = {}) => {
  try {
    const response = await api.get(
      "/indv/CourseAurthor/Get-List",
      {
        params: {
          PageNumber: pageNumber,
          PageSize: pageSize,
          OrderByLatest: orderByLatest
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching authors:", error);
    throw error;
  }
};


// Create new author
export const createAuthor = async (authorData) => {
  try {
    console.log(" Creating new author...", authorData);
    
    const response = await api.post("/indv/CourseAurthor/Create", authorData);
    
    console.log(" Author created successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error creating author:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });
    throw error;
  }
};

// Add this function to your Services/CourseService.js file

// Update author
export const updateAuthor = async (authorData) => {
  try {
    console.log(" Updating author...", authorData);

    // Validate required fields
    if (!authorData.authorId) {
      throw new Error("Author ID is required");
    }

    if (!authorData.name || !authorData.name.trim()) {
      throw new Error("Author name is required");
    }

    if (!authorData.email || !authorData.email.trim()) {
      throw new Error("Author email is required");
    }

    if (!authorData.linkedInProfile || !authorData.linkedInProfile.trim()) {
      throw new Error("LinkedIn profile is required");
    }

    // Validate LinkedIn URL format
    const linkedInRegex = /^https:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-]+\/?$/;
    if (!linkedInRegex.test(authorData.linkedInProfile.trim())) {
      throw new Error("Please enter a valid LinkedIn profile URL (e.g., https://www.linkedin.com/in/username)");
    }

    const payload = {
      authorId: parseInt(authorData.authorId),
      name: authorData.name.trim(),
      email: authorData.email.trim(),
      linkedInProfile: authorData.linkedInProfile.trim(),
      bio: authorData.bio ? authorData.bio.trim() : ""
    };

    console.log(" Update author payload:", JSON.stringify(payload, null, 2));

    const response = await api.put("/indv/CourseAurthor/Update", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    console.log(" Author updated successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error updating author:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });

    if (error.response?.data?.errors) {
      console.error("📋 Author validation errors:", error.response.data.errors);
    }

    throw new Error(
      error.response?.data?.title ||
        error.response?.data?.message ||
        error.response?.data?.details ||
        error.message ||
        "Failed to update author"
    );
  }
};

// publish course
export const publishCourse = async (courseId) => {
  try {
    console.log(" Publishing course with ID:", courseId);
    
    // Try PUT method instead of POST
    const response = await api.put(`/indv/Course/Push-To-Publish`, {
      courseId: parseInt(courseId)
    });
    
    console.log(" Course published successfully");
    return response.data;
  } catch (error) {
    console.error(" Error publishing course:", error);
    throw error;
  }
};

// Update Course
export const updateCourse = async (courseData) => {
  try {
    console.log(" Updating course...", courseData);

    const payload = {
      courseId: Number(courseData.courseId),
      title: courseData.title?.trim() || "",
      authorId: Number(courseData.authorId),                       // ✅ REQUIRED
      categoryId: Number(courseData.categoryId),                   // ✅ REQUIRED
      subCategories: courseData.subCategories || [],               // ✅ REQUIRED
      description: courseData.description?.trim() || "",
      forceUpdateIfPublished: courseData.forceUpdateIfPublished || false,
    };

    console.log(" Update payload:", payload);

    const response = await api.put("/indv/Course/Update", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    console.log(" Course updated successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error updating course:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });

    throw new Error(
      error.response?.data?.title ||
        error.response?.data?.message ||
        error.response?.data?.details ||
        "Failed to update course"
    );
  }
};



// In Services/CourseListService.js
export const updateCoursePrerequisites = async (courseId, prerequisites, forceUpdate = false) => {
  try {
    const payload = {
      courseId: parseInt(courseId),
      prerequisites: prerequisites, // Send array of strings directly
      forceUpdateIfPublished: forceUpdate
    };

    console.log(" Prerequisites update payload:", payload);

    const response = await api.put("/indv/Course/Prerequisite/UpdateList", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    console.log(" Prerequisites updated successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error updating prerequisites:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    
    throw new Error(
      error.response?.data?.title ||
        error.response?.data?.message ||
        error.response?.data?.details ||
        "Failed to update prerequisites"
    );
  }
};
// create course Module
export const createCourseModule = async (moduleData) => {
  try {
    console.log(" Creating course module...", moduleData);

    const formData = new FormData();

    // Basic fields
    formData.append("CourseId", moduleData.courseId.toString());
    formData.append("Title", moduleData.title);
    formData.append("Description", moduleData.description);
    formData.append("Order", moduleData.order.toString());
    formData.append("ModuleFile", moduleData.moduleFile);

    // Debug
    console.log(" FormData structure:");
    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    const response = await api.post("/indv/CourseModule/Create", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    console.log(" Module created successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error creating module:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });

    if (error.response?.data?.errors) {
      console.error("📋 Validation errors:", error.response.data.errors);
    }
throw error;  

  }
};

// update course module 
export const updateCourseModule = async (moduleData) => {
  try {
    console.log(" Updating course module...", moduleData);

    const formData = new FormData();

    // Basic fields
    formData.append("ModuleId", moduleData.moduleId.toString());
    formData.append("ModuleFileChanged", moduleData.moduleFileChanged.toString());
    formData.append("Title", moduleData.title);
    formData.append("Description", moduleData.description);
    
    // Only append file if it's changed
    if (moduleData.moduleFileChanged && moduleData.moduleFile) {
      formData.append("ModuleFile", moduleData.moduleFile);
    }

    // Debug
    console.log(" Update FormData structure:");
    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    const response = await api.put("/indv/CourseModule/Update", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    console.log(" Module updated successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error updating module:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });

    if (error.response?.data?.errors) {
      console.error("📋 Validation errors:", error.response.data.errors);
    }

    throw new Error(
      error.response?.data?.title ||
        error.response?.data?.message ||
        error.response?.data?.details ||
        "Failed to update module"
    );
  }
};

// Assessment Creation Function
export const createAssessment = async (assessmentData) => {
  try {
    console.log(" Creating assessment...", assessmentData);

    // Validate required fields
    if (!assessmentData.moduleId) {
      throw new Error("Module ID is required");
    }

    if (!assessmentData.title || !assessmentData.title.trim()) {
      throw new Error("Assessment title is required");
    }

    if (!assessmentData.questions || !Array.isArray(assessmentData.questions) || assessmentData.questions.length === 0) {
      throw new Error("At least one question is required");
    }

    // Validate questions structure
    for (let i = 0; i < assessmentData.questions.length; i++) {
      const question = assessmentData.questions[i];

      if (!question.questionText || !question.questionText.trim()) {
        throw new Error(`Question ${i + 1} text is required`);
      }

      if (!question.options || !Array.isArray(question.options) || question.options.length < 3) {
        throw new Error(`Question ${i + 1} must have at least 3 options`);
      }

      // Validate options
      for (let j = 0; j < question.options.length; j++) {
        const option = question.options[j];

        if (!option.text || !option.text.trim()) {
          throw new Error(`Option ${j + 1} in question ${i + 1} must have text`);
        }

        // Convert string "true"/"false" to boolean
        if (typeof option.isCorrect !== "boolean") {
          option.isCorrect = option.isCorrect === "true" || option.isCorrect === true;
        }
      }

      // ✔ REQUIRE AT LEAST 1 CORRECT ANSWER (ALLOW MORE THAN 1)
      const correctOptions = question.options.filter(opt => opt.isCorrect === true);
      if (correctOptions.length < 1) {
        throw new Error(`Question ${i + 1} must have at least 1 correct answer`);
      }
    }

    const payload = {
      moduleId: parseInt(assessmentData.moduleId),
      title: assessmentData.title.trim(),
      questions: assessmentData.questions.map((question, index) => ({
        questionText: question.questionText.trim(),
        order: parseInt(question.order) || (index + 1),
        options: question.options.map((option) => ({
          text: option.text.trim(),
          isCorrect: option.isCorrect === true || option.isCorrect === "true",
        }))
      }))
    };

    console.log("📝 Final assessment payload:", JSON.stringify(payload, null, 2));

    const response = await api.post("/indv/Assessment/Create", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    console.log(" Assessment created successfully:", response.data);
    return response.data;

  } catch (error) {
    console.error(" Error creating assessment:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });

    if (error.response?.data?.errors) {
      console.error("📋 Assessment validation errors:", error.response.data.errors);
    }

    throw new Error(
      error.response?.data?.title ||
      error.response?.data?.message ||
      error.response?.data?.details ||
      error.message ||
      "Failed to create assessment"
    );
  }
};


// Get Module Details with Assessment Info
export const getModuleWithDetails = async (moduleId) => {
  try {
    console.log(" Fetching module details...", moduleId);

    const response = await api.get(`/indv/CourseModule/Get-With-Detail/${moduleId}`);
    
    console.log(" Module details fetched successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error fetching module details:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });

    throw new Error(
      error.response?.data?.title ||
        error.response?.data?.message ||
        error.response?.data?.details ||
        "Failed to fetch module details"
    );
  }
};

// Check if module has assessment
export const checkModuleHasAssessment = async (moduleId) => {
  try {
    const moduleDetails = await getModuleWithDetails(moduleId);
    return {
      hasAssessment: moduleDetails.hasAssessment || false,
      moduleDetails: moduleDetails
    };
  } catch (error) {
    console.error(" Error checking module assessment:", error);
    throw error;
  }
};




// get page data
export const getPageData = async (moduleId, pageId, isAssessment = false) => {
  try {
    console.log(" Fetching page data for module:", moduleId, "pageId:", pageId);
    
    const response = await api.get(`/indv/CourseModule/admin/Get-Page`, {
      params: {
        moduleId: parseInt(moduleId),
        pageId: parseInt(pageId),
        isAssessment: isAssessment
      }
    });
    
    console.log(" Page data received:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error fetching page data:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });
    
    // Enhance error with more context
    const enhancedError = new Error(
      error.response?.status === 500 
        ? 'Server error loading page data' 
        : error.message || 'Failed to load page data'
    );
    enhancedError.status = error.response?.status;
    enhancedError.originalError = error;
    
    throw enhancedError;
  }
};

export const getPageFile = async (pageFileId) => {
  try {
    console.log("📁 Fetching page file for ID:", pageFileId);
    
    // Validate pageFileId first
    if (!pageFileId || pageFileId <= 0) {
      throw new Error(`Invalid pageFileId: ${pageFileId}`);
    }

    let response;
    
    try {
      // First try with blob response type
      response = await api.get(`/indv/CourseModule/page-file/${pageFileId}`, {
        responseType: 'blob',
        timeout: 15000 // 15 second timeout
      });
    } catch (error1) {
      console.log("⚠️ Option 1 failed, trying Option 2...", error1.message);
      
      // Second try without specifying responseType
      response = await api.get(`/indv/CourseModule/page-file/${pageFileId}`, {
        timeout: 15000
      });
    }
    
    // Check if response data is valid
    if (!response.data) {
      throw new Error('No data received from server');
    }

    console.log(" Page file received, size:", response.data.size, "bytes");
    return response.data;
    
  } catch (error) {
    console.error(" Error fetching page file:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });
    
    // Check if we got a blob error response
    if (error.response?.data instanceof Blob) {
      try {
        const errorText = await error.response.data.text();
        console.error("📄 Server error response:", errorText);
      } catch (blobError) {
        console.error(" Could not read error blob:", blobError);
      }
    }
    
    // Enhance the error with more context
    const enhancedError = new Error(
      error.response?.status === 500 
        ? `Server error: File ${pageFileId} is unavailable` 
        : error.message || 'Failed to load file'
    );
    enhancedError.status = error.response?.status;
    enhancedError.originalError = error;
    
    throw enhancedError;
  }
};


